/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ plan_price: NonNullable<unknown> }} Onboarding_Paywall_Plan_PriceInputs */

const en_onboarding_paywall_plan_price = /** @type {(inputs: Onboarding_Paywall_Plan_PriceInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.plan_price} / year`)
};

const ar_onboarding_paywall_plan_price = /** @type {(inputs: Onboarding_Paywall_Plan_PriceInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.plan_price} / سنة`)
};

const de_onboarding_paywall_plan_price = /** @type {(inputs: Onboarding_Paywall_Plan_PriceInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.plan_price} / Jahr`)
};

const es_onboarding_paywall_plan_price = /** @type {(inputs: Onboarding_Paywall_Plan_PriceInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.plan_price} / año`)
};

const fr_onboarding_paywall_plan_price = /** @type {(inputs: Onboarding_Paywall_Plan_PriceInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.plan_price} / an`)
};

const it_onboarding_paywall_plan_price = /** @type {(inputs: Onboarding_Paywall_Plan_PriceInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.plan_price} / anno`)
};

const ja_onboarding_paywall_plan_price = /** @type {(inputs: Onboarding_Paywall_Plan_PriceInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.plan_price}/年`)
};

const ko_onboarding_paywall_plan_price = /** @type {(inputs: Onboarding_Paywall_Plan_PriceInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.plan_price}/년`)
};

const pt_br_onboarding_paywall_plan_price = /** @type {(inputs: Onboarding_Paywall_Plan_PriceInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.plan_price}/ano`)
};

const ru_onboarding_paywall_plan_price = /** @type {(inputs: Onboarding_Paywall_Plan_PriceInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.plan_price} / год`)
};

const th_onboarding_paywall_plan_price = /** @type {(inputs: Onboarding_Paywall_Plan_PriceInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.plan_price} / ปี`)
};

const tr_onboarding_paywall_plan_price = /** @type {(inputs: Onboarding_Paywall_Plan_PriceInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.plan_price} / yıl`)
};

const zh_cn_onboarding_paywall_plan_price = /** @type {(inputs: Onboarding_Paywall_Plan_PriceInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.plan_price} / 年`)
};

const zh_tw_onboarding_paywall_plan_price = /** @type {(inputs: Onboarding_Paywall_Plan_PriceInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.plan_price} / 年`)
};

/**
* | output |
* | --- |
* | "{plan_price} / year" |
*
* @param {Onboarding_Paywall_Plan_PriceInputs} inputs
* @param {{ locale?: "en" | "ar" | "de" | "es" | "fr" | "it" | "ja" | "ko" | "pt_br" | "ru" | "th" | "tr" | "zh_cn" | "zh_tw" }} options
* @returns {LocalizedString}
*/
export const onboarding_paywall_plan_price = /** @type {((inputs: Onboarding_Paywall_Plan_PriceInputs, options?: { locale?: "en" | "ar" | "de" | "es" | "fr" | "it" | "ja" | "ko" | "pt_br" | "ru" | "th" | "tr" | "zh_cn" | "zh_tw" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Onboarding_Paywall_Plan_PriceInputs, { locale?: "en" | "ar" | "de" | "es" | "fr" | "it" | "ja" | "ko" | "pt_br" | "ru" | "th" | "tr" | "zh_cn" | "zh_tw" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_onboarding_paywall_plan_price(inputs)
	if (locale === "ar") return ar_onboarding_paywall_plan_price(inputs)
	if (locale === "de") return de_onboarding_paywall_plan_price(inputs)
	if (locale === "es") return es_onboarding_paywall_plan_price(inputs)
	if (locale === "fr") return fr_onboarding_paywall_plan_price(inputs)
	if (locale === "it") return it_onboarding_paywall_plan_price(inputs)
	if (locale === "ja") return ja_onboarding_paywall_plan_price(inputs)
	if (locale === "ko") return ko_onboarding_paywall_plan_price(inputs)
	if (locale === "pt_br") return pt_br_onboarding_paywall_plan_price(inputs)
	if (locale === "ru") return ru_onboarding_paywall_plan_price(inputs)
	if (locale === "th") return th_onboarding_paywall_plan_price(inputs)
	if (locale === "tr") return tr_onboarding_paywall_plan_price(inputs)
	if (locale === "zh_cn") return zh_cn_onboarding_paywall_plan_price(inputs)
	return zh_tw_onboarding_paywall_plan_price(inputs)
});